<!-- @format -->

<template>
    <div>
        <HeaderWithCountDown
            :date-time-till="dateTimeTill"
            :show-language-selector="!isManageBookingFlow"
            @finish="expire()" />
        <div
            class="content-max-width d-flex"
            :class="$vuetify.breakpoint.mdAndUp ? 'flex-row items-center' : 'flex-column'">
            <div class="col col-12 col-md-7 pb-0">
                <slot name="left"></slot>
                <BillingDetailsForm :billing-details="billingDetails" />
            </div>
            <div class="col col-12 col-md-5">
                <slot name="right"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import HeaderWithCountDown from '@tenant/app/views/cart/TheCheckout/HeaderWithCountDown.vue';
import EventFlowMixin from '@tenant/app/mixins/EventFlowMixin';
import { addSeconds } from '@tenant/app/utils/dateUtils.js';
import BillingDetailsForm from './BillingDetailsForm';

export default {
    name: 'ManageBookingCheckoutLayout',
    components: {
        BillingDetailsForm,
        HeaderWithCountDown,
    },
    mixins: [EventFlowMixin],
    props: {
        billingDetails: {
            type: Object,
            default: () => ({}),
        },
        countDownLimitMinutes: {
            type: Number,
            default: 10,
        },
    },
    computed: {
        dateTimeTill() {
            const date = new Date();
            return addSeconds(date, this.countDownLimitMinutes * 60);
        },
    },
    methods: {
        ...mapActions({
            notificationError: 'notification/error',
        }),
        expire() {
            this.$router.go(-1);
            this.notificationError(this.$t('_common:messages.cartExpired'));
        },
    },
};
</script>
